import "%modules%/header/header";
import "%modules%/landing/landing";
import "%modules%/landing-slider/landing-slider";
import "%modules%/video/video";
import "%modules%/webinar-help/webinar-help";
import "%modules%/blog-book/blog-book";
import "%modules%/modal/modal";
import "%modules%/all-articles/all-articles";
import "%modules%/footer/footer";
